module.exports = __webpack_public_path__ + "static/media/geovisor.960c08a0.png";